# Welcome to the closed beta

You're one of the first twelve teams using Cairn in real work. This page is the lightweight handbook for that program: what to expect, how to give feedback, and where to find us when something goes sideways.

## What's stable today

- **Voice walkthrough → YAML** via `cairn record`
- **`cairn run`** executing flows via Playwright
- **`cairn scan`** + drift detection on PR via the GitHub Action
- **Dashboard**: teams, projects, flows, FlowViewer, live run step-by-step, drift report, AI Models per-task overrides
- **Cost meters** writing usage docs from day one (no pricing tiers yet — see /teams/.../billing)

## What's gated behind beta-cohort access

A few features are wired but only enabled for cohort teams (`teams/{teamId}.is_beta = true`). These render an extra **Beta** badge in the dashboard header when you're in a cohort team:

- **In-product feedback button** (top right) — sends straight to our shared Slack channel with team + project + recent traceId context
- Early access to V1.5 features when they land (live overlay preview, BYOK secret-storage UI)

## Office hours

Every other Friday, 11am Pacific. The calendar link lives in the beta-feedback Slack channel — open `Send feedback` and ask if you need it re-shared.

Office hours are optional. They exist for two reasons:

1. We watch you use Cairn for 15 minutes and learn what's broken
2. You ask us anything

We never use office hours to demo new features. If we have something to show, it goes in the cohort Slack first.

## Giving feedback

Three paths, in order of preference:

1. **Send feedback button** in the dashboard top bar (cohort teams only) — fastest path, automatic context attachment
2. **Cohort Slack** for conversation-shaped feedback or questions
3. **GitHub issues** at [cairntools/cairn](https://github.com/cairntools/cairn) for bugs you can repro independently

Anything goes — bugs, papercuts, "this label is wrong", "the docs page for X is confusing". We read every message.

## What we ask in return

- One short answer to "would you use this if it cost $X / month at GA" when we ask (post-beta, ~Q4)
- Permission to credit your company on the marketing landing page (opt-in; we won't list you without explicit yes)
- A 20-minute exit interview when GA ships, so we know what to keep and what to drop

You can leave the cohort at any time — we'll remove the `is_beta` flag, the **Beta** badge disappears, the dashboard works exactly the same. Your data stays.

## Cohort companies

Cohort credits on the marketing landing read from `cohort_credits/{teamId}` in Firestore. Once you've opted in via Slack we'll add you; you can revoke at any time and the badge disappears within a deploy.
